import React from 'react';
import ReactDOM from 'react-dom';

// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { ToastContainer, toast } from 'react-toastify';
import Modal from 'react-modal';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import './css/bootstrap.css';
import './css/app.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'font-awesome/css/font-awesome.min.css';

Modal.setAppElement('#root');
ReactDOM.render(
	<React.StrictMode>
		<App />
		<ToastContainer />
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
